import { render, staticRenderFns } from "./DeleteResultsModal.vue?vue&type=template&id=1ee825ae&scoped=true"
import script from "./DeleteResultsModal.vue?vue&type=script&lang=js"
export * from "./DeleteResultsModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteResultsModal.vue?vue&type=style&index=0&id=1ee825ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee825ae",
  null
  
)

export default component.exports